import { useLocation } from "react-router-dom";
import { Flex, Space, Text, Title } from "@mantine/core";

const Welcome: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get("n");
  const status = queryParams.get("s");

  return (
    <Flex
      h="80vh"
      justify="center"
      align="center"
      direction="column"
      ta="center"
    >
      <Text component="div" maw="600px">
        <Title order={3}>
          Hello{name && " " + name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()},
        </Title>
        {status == "pending"
          ? <Title order={4} fw="normal" mt="md">
            We have noticed that your company&apos;s admin has sent an invite to your email for the portal access and this has not yet been accepted.
            <Space h="lg" />
            Please check you email and accept the invite. After this, you should receive a mail confirming access to the DNA portal.
            If you do not see the invitation in your mailbox, please request your company&apos;s admin to resend the invitation.
            <Space h="lg" />
            For any further question, please reach out to support@audinate.com
          </Title>
          : <Title order={4} fw="normal" mt="md">
            You do not have access to the DNA portal, please contact your company admin. If you are here by mistake and need further assistance, please contact support@audinate.com.
          </Title>
        }
      </Text>
    </Flex >
  );
};

export default Welcome;